<ui-box [highlight]="highlight" [highlightPosition]="highlightPosition">
  <ng-content></ng-content>
</ui-box>
